import { lazy, Suspense } from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { navButtonClassName } from "@/components/forms/form-styles";
import { useSensoryProfileSession } from "@/components/sensory-profile/sensory-profile-session";
import { firstSensoryProfileStepId } from "@/lib/routes";

const SensoryProfileSubmitted = lazy(() =>
  import("@/components/sensory-profile/sensory-profile-submitted").then(
    (module) => ({ default: module.SensoryProfileSubmitted }),
  ),
);

export const Route = createFileRoute("/sensory-profile/submitted")({
  component: SensoryProfileSubmittedPage,
});

function SensoryProfileSubmittedPage() {
  const { submitted, startOver } = useSensoryProfileSession();

  if (!submitted) {
    return (
      <Navigate
        to="/sensory-profile/$stepId"
        params={{ stepId: firstSensoryProfileStepId() }}
      />
    );
  }

  return (
    <Suspense fallback={null}>
      <SensoryProfileSubmitted
        data={submitted}
        onStartOver={startOver}
        navButtonClassName={navButtonClassName}
      />
    </Suspense>
  );
}
